import { useContext, useState, useEffect } from "react"

import { StoreContext } from "./DataStore"

/**
 * Returns a reference to the DataStore.
 */
export function useStore() {
    return useContext(StoreContext)
}

/**
 * Returns a reference to the filtered application data.
 * Changes on reloads.
 */
export function useStoreData(key = "viewState") {
    const store = useContext(StoreContext)
    const [cachedData, setCachedData] = useState(store[key])

    if (typeof store[key] === "undefined") {
        throw new Error("No such store property: " + key)
    }

    useEffect(
        function() {
            store.on(`change:${key}`, setCachedData)
            return function() {
                store.off(`change:${key}`, setCachedData)
            }
        },
        [store, key],
    )

    return cachedData
}

/**
 * Returns an object {isPublic, isPrivate, isFull} for easy variant switches.
 */
export function useVariant() {
    const variant = useStoreData("variant")

    return {
        variant, // Needed by app.js for body classes
        isPublic: variant === "Public",
        isPrivate: variant === "Private",
        isFull: variant === "Full",
    }
}
